import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AlertIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 15.3653C11.866 15.3653 15 12.2313 15 8.36526C15 4.49927 11.866 1.36526 8 1.36526C4.13401 1.36526 1 4.49927 1 8.36526C1 12.2313 4.13401 15.3653 8 15.3653ZM7.02625 4.89023C7.01197 4.60464 7.23968 4.36526 7.52562 4.36526H8.47438C8.76032 4.36526 8.98803 4.60464 8.97375 4.89023L8.77375 8.89023C8.76045 9.15633 8.54081 9.36526 8.27438 9.36526H7.72562C7.45919 9.36526 7.23955 9.15633 7.22625 8.89023L7.02625 4.89023ZM7 11.3653C7 10.813 7.44772 10.3653 8 10.3653C8.55228 10.3653 9 10.813 9 11.3653C9 11.9176 8.55228 12.3653 8 12.3653C7.44772 12.3653 7 11.9176 7 11.3653Z"
		/>
	</svg>
))
